import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import Tooltip from "@mui/material/Tooltip";
import { HXTooltipContentContainer } from "./HXTooltipWrapperView.styles";
export const HXTooltipWrapperView = observer((props) => {
    const { tooltip, show, children, placement, arrow, stretch, align, addTouchControls, offset, maxWidth, color, backgroundColor, boxShadow, padding, } = props;
    const sx = {};
    const arrowSx = {};
    if (maxWidth !== undefined)
        sx.maxWidth = maxWidth;
    if (color)
        sx.color = color;
    if (backgroundColor) {
        sx.backgroundColor = backgroundColor;
        arrowSx.color = backgroundColor;
    }
    if (boxShadow)
        sx.boxShadow = boxShadow;
    if (padding)
        sx.padding = padding;
    return (_jsx(Tooltip, { title: show !== false ? tooltip : null, placement: placement, arrow: arrow, componentsProps: {
            tooltip: {
                sx,
            },
            arrow: {
                sx: arrowSx,
            },
        }, PopperProps: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: offset !== null && offset !== void 0 ? offset : [0, 0],
                    },
                },
            ],
        }, ...(addTouchControls ? { enterTouchDelay: 0, leaveTouchDelay: 15000 } : {}), children: _jsx(HXTooltipContentContainer, { stretch: stretch, align: align, children: children }) }));
});
